<template>
  <div class="ticker-renderer" @click="onHeaderClick">
    <span class="name">{{ params.displayName }}</span>
    <span class="ag-icon" :class="{ 'ag-icon-asc': currentSort === 'asc', 'ag-icon-desc': currentSort === 'desc' }" />
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'ticker-header-renderer',
  data() {
    return {
      params: null,
      currentSort: 'custom',
      sortingOrder: ['asc', 'desc', 'custom']
    };
  },
  methods: {
    onHeaderClick() {
      if (this.params.enableSorting) {
        const index = this.sortingOrder.indexOf(this.currentSort);
        let nextSort = this.sortingOrder[(index + 1) % this.sortingOrder.length];
        this.params.context.setCustomTickerSort(nextSort === 'custom');
        if (nextSort === 'custom') nextSort = 'asc';

        if (this.currentSort === 'custom') this.params.setSort(null); //resetting to null before applying asc again (needed for custom (asc) -> asc)
        this.params.setSort(nextSort);
      }
    },
    onSortChanged() {
      if (this.params.enableSorting) {
        const columnState = this.params.columnApi
          .getColumnState()
          .find(state => state.colId === 'q._TCR' && state.sort);
        const isCustom = this.params.context.customTickerSort;
        this.currentSort = isCustom || !columnState ? 'custom' : columnState.sort;
      }
    }
  },
  mounted() {
    this.params.column.addEventListener('sortChanged', this.onSortChanged);
    this.onSortChanged();
  },
  refresh(params) {
    this.params = params;
    return true;
  },
  beforeDestroy() {
    this.params.column.removeEventListener('sortChanged', this.onSortChanged);
  }
});
</script>

<style lang="scss" scoped>
.ticker-renderer {
  .name {
    float: left;
  }
}
</style>
